// extracted by mini-css-extract-plugin
export default {"wapperTable":"Table_wapperTable__rj6sx"};